import React, { Suspense, useEffect } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import JumboApp from "@jumbo/components/JumboApp";
import AppLayout from "./AppLayout";
import JumboTheme from "@jumbo/components/JumboTheme";
import AppRoutes from "./AppRoutes";
import configureStore, { history } from "./redux/store";
import JumboDialog from "@jumbo/components/JumboDialog";
import JumboDialogProvider from "@jumbo/components/JumboDialog/JumboDialogProvider";
import { SnackbarProvider } from "notistack";
import AppProvider from "./AppProvider";
import { config } from "./config/main";
import JumboRTL from "@jumbo/JumboRTL/JumboRTL";
import Div from "@jumbo/shared/Div";
import { CircularProgress } from "@mui/material";
import JumboAuthProvider from "@jumbo/components/JumboAuthProvider";
import store, { dispatch } from "./store/store";
import { changeFavicon } from "./utils/FaviconUtil";

import { GetAllPreloadDataListThunk } from "./store/slice/common-slice";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useEffect(() => {
    let appTitle = "DSP Dashboard";
    let newFaviconUrl = "/images/logo-short.png";
    const currentDomain = window.location.hostname;

    if (currentDomain.indexOf("adfuel.us") != -1) {
      appTitle = "AdFuel DSP";
      newFaviconUrl = "/images/adfuel_favicon.png";
    } else if (currentDomain.indexOf("contextnetworks.net") != -1) {
      appTitle = "Context Networks DSP";
      newFaviconUrl = "/images/context_favicon.png";
    } else if (currentDomain.indexOf("savvydsp.com") != -1) {
      appTitle = "Savvy DSP";
      newFaviconUrl = "/images/savvy_media_favicon.png";
    } else if (currentDomain.indexOf("arrowmarketinglabs.com") != -1) {
      appTitle = "Arrow Marketinglabs DSP";
      newFaviconUrl = "/images/arrow_marketing_favicon.png";
    } else if (currentDomain.indexOf("perfectaudience.io") != -1) {
      appTitle = "Perfect Audience DSP";
      newFaviconUrl = "/images/Perfect_Audience_favicon.png";
    } else if (currentDomain.indexOf("advangelists.com") != -1) {
      appTitle = "Advangelists DSP";
    }

    document.title = appTitle;
    changeFavicon(newFaviconUrl);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter history={history}>
          <AppProvider>
            <JumboApp activeLayout={config.defaultLayout}>
              <JumboTheme init={config.theme}>
                <JumboRTL>
                  <JumboDialogProvider>
                    <JumboDialog />
                    <SnackbarProvider
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      maxSnack={3}
                    >
                      <AppLayout>
                        <Suspense
                          fallback={
                            <Div
                              sx={{
                                display: "flex",
                                minWidth: 0,
                                alignItems: "center",
                                alignContent: "center",
                                height: "100%",
                              }}
                            >
                              <CircularProgress sx={{ m: "-40px auto 0" }} />
                            </Div>
                          }
                        >
                          <AppRoutes />
                        </Suspense>
                      </AppLayout>
                    </SnackbarProvider>
                  </JumboDialogProvider>
                </JumboRTL>
              </JumboTheme>
            </JumboApp>
          </AppProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
